module.exports = __webpack_public_path__ + "static/egyptian-fitted-sheet-dusty-rose-1-51a6729027a8b5dcaf0ed9d4847686cf.webp";